module.exports = __webpack_public_path__ + "media/images/slider_up-02266d1516210a6cb9e3a72546d13bda.png";